export const ALLOWED_USER_CHART_EXTENSIONS = ['pdf', 'tif', 'tiff', 'mbtiles'] as const

export type UserChartExtension = (typeof ALLOWED_USER_CHART_EXTENSIONS)[number]

export const USER_CHART_MAX_SIZE_MB_PDF_TIFF = 50
export const USER_CHART_MAX_SIZE_MB_MBTILES = 3072

export const MAX_USER_CHARTS = 50
export const MAX_ACTIVE_USER_CHARTS = 100

export const USER_CHART_NAME_MAX_LENGTH = 100

export const USER_CHART_UPLOAD_SPEED_FAST_THRESHOLD_BPS = 100 * 1024
